import { ref, watch } from 'vue';

/**
 * A composable for animating a value and toggling an animation flag when the value changes.
 * @param {Ref|ComputedRef} watchedValue - The value to watch for changes.
 * @param {number} duration - Animation duration in milliseconds (default: 500ms)
 * @returns {[Ref, Ref]} [animatedValue, animateFlag]
 */
export function useAnimatedValue(watchedValue, duration = 500) {
  const animatedValue = ref(watchedValue.value);
  const animateFlag = ref(false);

  watch(
    watchedValue,
    (newValue, oldValue) => {
      if (animateFlag.value) return;
      if (newValue !== oldValue) {
        animatedValue.value = newValue;
        animateFlag.value = true;
        setTimeout(() => {
          animateFlag.value = false;
        }, duration);
      }
    },
    { immediate: true }
  );

  return [animatedValue, animateFlag];
}
